.template-content > * {
  max-width: 875px;
}

.summary {
  padding-bottom: 20px;
}

.grid-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-buttons {
  align-items: center;
}

.tab-content {
  min-height: unset;
}

.additional-form-field {
  min-width: 0;
}
